import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const InvestorRouteWrapper = ({ children }) => {
  const { user, userType } = useSelector((state) => state.user)
  const kycStatus = user.status

  if (userType === "ADMIN")
    return (
      <Navigate
        to={{
          pathname: "/forbidden",
        }}
      />
    )

  if (kycStatus !== "APPROVED")
    return (
      <Navigate
        to={{
          pathname: "/dashboard",
        }}
      />
    )

  return children
}

export default InvestorRouteWrapper
